
import React, { useContext, useEffect, useState } from 'react'
import { FiCalendar } from 'react-icons/fi'
import { Formik, Form } from 'formik'

import { Container } from './styles'
import { Button, Select, Textarea, Textbox } from '~/components/Form'
import masks from '~/util/masks'
import Spinner from '~/components/Spinner'
import { api } from '~/services/api'
import { TipContext } from '~/contexts/TipContext'
import { loadTips } from '~/util/tip'
import Yup from '~/services/yup'

const baseValidation = Yup.object().shape({
	instituicao: Yup.string().ensure().required('Selecione a instituição.'),
	motivo: Yup.string(),
	data_prevista: Yup.string().nullable().required('Especifique a data.'),
	assunto: Yup.string().ensure().required('Selecione a instituição.')
})
export default function ({ handleCadastrar, assuntos }) {
	const { setCodigo, tips } = useContext(TipContext)

	const [instituicoes, setInstituicoes] = useState(null)

	const [validation, setValidation] = useState(baseValidation)

	async function loadInstituicoes() {
		const response = await api.get('instituicao')

		setInstituicoes(response)
	}

	useEffect(() => {
		loadInstituicoes()

		loadTips(setCodigo, 'form_visita_diretoria_cadastro')
	}, [])

	if (!assuntos || !instituicoes) {
		return <Spinner />
	}

	return (
		<Container>
			<p style={{ gridArea: 'tip', margin: 8 }}>{tips?.formulario}</p>

			<Formik
				onSubmit={handleCadastrar}
				initialValues={{
					instituicao: null,
					motivo: '',
					instituicao_descricao: '',
					data_prevista: '',
					assunto: null
				}}
				validationSchema={validation}
				enableReinitialize
			>
				{({ setFieldValue, values, isSubmitting, errors }) => (
					<Form>
						<Container className="flex flex-col md:grid md:grid-cols-2 lg:grid-cols-3">
							<div className="flex flex-col gap-1">
								<Select
									name="instituicao"
									label="Instituição"
									options={[
										{ label: 'Outros', value: 0 },
										...instituicoes.map(i => ({
											label: i.nome_fantasia,
											value: i.id
										}))
									]}
									onChange={(selected, meta) => {
										if (selected.value === 0) {
											setValidation(baseValidation.concat(Yup.object().shape({
												instituicao_descricao: Yup.string().required('Informe o nome da Instituição.')
											})))
										} else {
											setValidation(baseValidation)
										}
										setFieldValue(meta.name, selected)
									}}
								/>

								{values.instituicao?.value === 0 && (
									<Textbox
										name="instituicao_descricao"
										label="Nome da instituição"
									/>
								)}
							</div>

							<Textarea
								name="motivo"
								label="Motivo"
								containerClass="lg:col-span-2"
							/>

							<Textbox
								name="data_prevista"
								label="Data prevista"
								mask={masks.date}
							/>

							<Select
								name="assunto"
								label="Assunto"
								options={assuntos}
								onChange={(selected, meta) => {
									setFieldValue(meta.name, selected)
								}}
							/>

							<Button type="submit" loading={isSubmitting} className="transparent self-end w-fit self-end md:col-span-2 lg:col-span-3 md:justify-self-end">
								Agendar atividade
								<FiCalendar size={16} />
							</Button>
						</Container>
					</Form>
				)}
			</Formik>
		</Container>
	)
}
